var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "params mt-5" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { staticClass: "form-label" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.__t("UKLON_LOGO")) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("fileload", {
            attrs: { doc_id: this.location.id, doc_type: "uklon_logo" },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }